__turbopack_context__.v({
  "affiliationsBlock": "ALRbUa_affiliationsBlock",
  "authorsBlock": "ALRbUa_authorsBlock",
  "referenceList": "ALRbUa_referenceList",
  "richText": "ALRbUa_richText",
  "w-richtext-align-center": "ALRbUa_w-richtext-align-center",
  "w-richtext-align-floatleft": "ALRbUa_w-richtext-align-floatleft",
  "w-richtext-align-floatright": "ALRbUa_w-richtext-align-floatright",
  "w-richtext-align-fullwidth": "ALRbUa_w-richtext-align-fullwidth",
  "w-richtext-align-normal": "ALRbUa_w-richtext-align-normal",
});
